import { Component, Inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CountryCode } from 'libphonenumber-js';
import { Logger } from '../../../../../../infrastructure/logging/logger';
import { Country } from '../../../../../../shared/address/Country';
import { State } from '../../../../../../shared/address/State';
import { CountryService } from '../../../../../../shared/reference/country.service';
import { ReferenceService } from '../../../../../../shared/reference/reference.service';
import { getCountryNameFromCountryId } from '../../../../../../utilities/CountryUtility';
import { formatPhoneNumber } from '../../../../../../utilities/PhoneUtility';
import { UserContextProvider } from '../../../../../../infrastructure/context/user-context-provider';

@Component({
  selector: 'app-guest-form-dialog',
  templateUrl: './guest-form-dialog.component.html',
  styleUrls: ['./guest-form-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatOptionModule,
    MatIcon,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
    MatButtonModule,
    MatExpansionModule
  ]
})
export class GuestFormDialogComponent implements OnInit {

  minDate!: Date;
  maxDate!: Date;
  states: State[] = [];
  countries: Country[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<GuestFormDialogComponent>,
    private referenceService: ReferenceService,
    private countryService: CountryService,
    private userContextProvider: UserContextProvider,
    private logger: Logger
  ) { }

  ngOnInit() {
    const today = new Date();
    this.minDate = new Date(1900, 0, 1);
    this.maxDate = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate()
    );

    if (this.data.existingGuest) {
      this.data.form.patchValue(this.data.guest);
      this.data.form.controls['birth_date'].setValue('');
      this.data.form.markAllAsTouched();
    }

    this.states = this.referenceService.getAllStates();
    this.countryService.getCountries()
      .then(countries => this.countries = countries)
      .catch(e => {
        this.logger.handleError(e, 'An error occurred while retrieving Countries', 'Error while retrieving Countries');
      });
  }

  cancelAddGuest() {
    this.data.form.reset();
    this.dialogRef.close(false);
  }

  canCreateGuest(): boolean {
    return (
      this.data.form.valid
    );
  }

  submitGuest() {
    let addedGuest: any;

    if (!this.data.editExistingGuest) {
      addedGuest = {
        ...this.data.form.value,
        verification_cost: this.data.verificationCost > 0 ? this.data.verificationCost : 0,
        verification_package: this.data.verificationPackage
      }

      if (addedGuest.address?.country_id) {
        addedGuest.address.country_name = getCountryNameFromCountryId(this.countries, addedGuest.address.country_id);
      }
    } else {
      addedGuest = {
        ...this.data.form.value
      }
    }

    this.data.form.reset();
    this.dialogRef.close(addedGuest);
  }

  onPhoneNumberChanged(event: Event) {
    this.updatePhoneNumber((event.target as HTMLInputElement).value);
  }

  updatePhoneNumber(phoneNumber: string) {
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber, this.userContextProvider.countryCode as CountryCode);
    this.data.form.patchValue({ phone_number: formattedPhoneNumber });
  }
}